import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const isPollExist = (id, name) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.IS_POLL_EXIST(id, name)
  );
};

export default isPollExist;
